import { render } from "./UploadInteractionsModal.vue?vue&type=template&id=28bf091a&scoped=true"
import script from "./UploadInteractionsModal.vue?vue&type=script&lang=js"
export * from "./UploadInteractionsModal.vue?vue&type=script&lang=js"

import "./UploadInteractionsModal.vue?vue&type=style&index=0&id=28bf091a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bf091a"],['__file',"UploadInteractionsModal.vue"]])

export default __exports__